import { FC, ReactNode } from "react";
import './slide-wrapper.scss';

export const SlideWrapper: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <div className="slider-wrapper">
            { children }
        </div>
    )
}